module.exports = __webpack_public_path__ + "static/media/Maf_banners-relacionamiento.a0eed15e.jpg";